import * as yup from "yup";
import { CantidadSchema } from "./CantidadSchema";
import { PersonaJuridicaSchema } from "./PersonaJuridicaSchema";

export const TratamientoExternoSchema = yup.object().shape({
  orden: yup.number().required("errors.tratamientoExterno.orden.required"),
  denominacion: yup
    .string()
    .max(100, "errors.tratamientoExterno.denominacion.max")
    .required("errors.tratamientoExterno.denominacion.required")
    .default(""),
  caudalAnual: CantidadSchema.required(
    "errors.tratamientoExterno.caudalAnual.required",
  )
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M3ANIO" } }),
  descripcion: yup
    .string()
    .max(1024, "errors.tratamientoExterno.descripcion.max")
    .required("errors.tratamientoExterno.descripcion.required")
    .default(""),
  conPeligrosidad: yup
    .boolean()
    .required("errors.tratamientoExterno.conPeligrosidad.required")
    .default(false),
  transportista: yup
    .object()
    .concat(PersonaJuridicaSchema)
    .when(["conPeligrosidad"], ([conPeligrosidad], schema) => {
      if (conPeligrosidad) {
        return schema.optional().nullable().default(null);
      } else {
        return schema
          .required("errors.tratamientoExterno.transportista.required")
          .default(PersonaJuridicaSchema.cast(undefined, { assert: false }));
      }
    })
    .default(null),
  tratador: yup
    .object()
    .concat(PersonaJuridicaSchema)
    .when(["conPeligrosidad"], ([conPeligrosidad], schema) => {
      if (conPeligrosidad) {
        return schema.optional().nullable().default(null);
      } else {
        schema
          .required("errors.tratamientoExterno.tratador.required")
          .default(PersonaJuridicaSchema.cast(undefined, { assert: false }));
      }
    }),
  frecuenciaRetiros: yup
    .object()
    .when(["conPeligrosidad"], ([conPeligrosidad], schema) => {
      if (conPeligrosidad) {
        return schema.optional().nullable().default(null);
      } else {
        schema
          .required("errors.tratamientoExterno.frecuenciaRetiros.required")
          .default(null);
      }
    }),
});
